module.exports = __webpack_public_path__ + "media/canada-goose-2.b01ae4bf.mp3";